import { Target, TargetType, SSIO } from '../types';

export const compareTargets = (t1: Target, t2: Target): boolean =>
  t1.type === TargetType.IO
    ? t1.type === t2.type && compareIO(t1.io, t2.io)
    : t1.type === t2.type && t1.id === t2.id;

export const compareIO = (io1: SSIO, io2: SSIO): boolean =>
  io1.type === io2.type && io1.node === io2.node && io1.index === io2.index;
